/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/router';
import * as import2 from '@angular/common';
import * as import3 from '@ngx-translate/core/src/translate.pipe';
import * as import4 from '@ngx-translate/core/src/translate.service';
import * as import5 from '../../../app/pipes/long-message.pipe';
import * as import6 from '../../../$$_gendir/node_modules/ng2-breadcrumb/app/components/breadcrumb.ngfactory';
import * as import7 from 'ng2-breadcrumb/app/components/breadcrumb';
import * as import8 from 'ng2-breadcrumb/app/components/breadcrumbService';
import * as import9 from '../../../app/layout/header.component';
import * as import10 from '../../../app/services/api.service';
import * as import11 from '../../../app/services/response.service';
import * as import12 from '../../../app/services/language.service';
import * as import13 from '../../../app/services/auth.service';
import * as import14 from '../../../app/services/user.service';
import * as import15 from '../../../app/services/company.service';
import * as import16 from '../../../app/services/local-storage.service';
import * as import17 from '../../../app/services/cart.service';
const styles_HeaderComponent:any[] = ([] as any[]);
export const RenderType_HeaderComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_HeaderComponent,
  data: {}
}
);
function View_HeaderComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[[
        'routerLink',
        '/'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Powrót do panelu klienta'])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/';
    ck(v,3,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,3).target;
    const currVal_1:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[[
        'routerLink',
        '/service/offer/company'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Podsumowanie koszyka'])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/service/offer/company';
    ck(v,3,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,3).target;
    const currVal_1:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1);
  });
}
function View_HeaderComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'a',[[
        'routerLink',
        '/messages/list'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'icon-bell-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',[[
        'class',
        'message-count-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/messages/list';
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵnov(v,1).target;
    const currVal_1:any = import0.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1);
    const currVal_3:any = co.unreadMessages;
    ck(v,6,0,currVal_3);
  });
}
function View_HeaderComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'target'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.changeCompany(v.context.$implicit.id)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
  });
}
function View_HeaderComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵppd(2)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov((<any>(<any>v.parent).parent),0),((((co.user == null)? (null as any): ((co.user.info == null)? (null as any): co.user.info.first_name)) + ' ') + ((co.user == null)? (null as any): ((co.user.info == null)? (null as any): co.user.info.last_name))),15));
    ck(v,1,0,currVal_0);
  });
}
function View_HeaderComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.user == null)? (null as any): co.user.email);
    ck(v,1,0,currVal_0);
  });
}
function View_HeaderComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),69,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_4)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'dropdown dropdown-company'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'trigger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'dropdown-menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_5)),
    import0.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'a',[[
        'routerLink',
        '/company/add'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,24).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),36,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),33,'div',[[
        'class',
        'login dropdown dropdown-user'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'trigger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_6)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_7)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'dropdown-menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'a',[
      [
        'class',
        'target'
      ]
      ,
      [
        'routerLink',
        '/profile/edit'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,47).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'a',[
      [
        'class',
        'target'
      ]
      ,
      [
        'routerLink',
        '/account/edit'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,55).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.logout()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.unreadMessages > 0);
    ck(v,5,0,currVal_0);
    const currVal_2:any = co.companies;
    ck(v,19,0,currVal_2);
    const currVal_5:any = '/company/add';
    ck(v,24,0,currVal_5);
    const currVal_7:any = (((co.user == null)? (null as any): ((co.user.info == null)? (null as any): co.user.info.first_name)) || ((co.user == null)? (null as any): ((co.user.info == null)? (null as any): co.user.info.last_name)));
    ck(v,38,0,currVal_7);
    const currVal_8:boolean = (!((co.user == null)? (null as any): ((co.user.info == null)? (null as any): co.user.info.first_name)) && !((co.user == null)? (null as any): ((co.user.info == null)? (null as any): co.user.info.last_name)));
    ck(v,40,0,currVal_8);
    const currVal_11:any = '/profile/edit';
    ck(v,47,0,currVal_11);
    const currVal_15:any = '/account/edit';
    ck(v,55,0,currVal_15);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (((co.company == null)? (null as any): co.company.name) || import0.ɵunv(v,13,0,import0.ɵnov(v,14).transform('GENERAL.COMPANY.NONE')));
    ck(v,13,0,currVal_1);
    const currVal_3:any = import0.ɵnov(v,24).target;
    const currVal_4:any = import0.ɵnov(v,24).href;
    ck(v,23,0,currVal_3,currVal_4);
    const currVal_6:any = import0.ɵunv(v,25,0,import0.ɵnov(v,26).transform('GENERAL.COMPANY.NEW'));
    ck(v,25,0,currVal_6);
    const currVal_9:any = import0.ɵnov(v,47).target;
    const currVal_10:any = import0.ɵnov(v,47).href;
    ck(v,46,0,currVal_9,currVal_10);
    const currVal_12:any = import0.ɵunv(v,48,0,import0.ɵnov(v,49).transform('GENERAL.YOURPROFILE'));
    ck(v,48,0,currVal_12);
    const currVal_13:any = import0.ɵnov(v,55).target;
    const currVal_14:any = import0.ɵnov(v,55).href;
    ck(v,54,0,currVal_13,currVal_14);
    const currVal_16:any = import0.ɵunv(v,56,0,import0.ɵnov(v,57).transform('GENERAL.ACCOUNTSETTINGS'));
    ck(v,56,0,currVal_16);
    const currVal_17:any = import0.ɵunv(v,63,0,import0.ɵnov(v,64).transform('GENERAL.LOGOUT'));
    ck(v,63,0,currVal_17);
  });
}
function View_HeaderComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'a',[[
        'routerLink',
        '/login'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,5).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'a',[[
        'routerLink',
        '/register'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,13).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/login';
    ck(v,5,0,currVal_2);
    const currVal_6:any = '/register';
    ck(v,13,0,currVal_6);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,5).target;
    const currVal_1:any = import0.ɵnov(v,5).href;
    ck(v,4,0,currVal_0,currVal_1);
    const currVal_3:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('GENERAL.SIGNIN'));
    ck(v,6,0,currVal_3);
    const currVal_4:any = import0.ɵnov(v,13).target;
    const currVal_5:any = import0.ɵnov(v,13).href;
    ck(v,12,0,currVal_4,currVal_5);
    const currVal_7:any = import0.ɵunv(v,14,0,import0.ɵnov(v,15).transform('GENERAL.REGISTER'));
    ck(v,14,0,currVal_7);
  });
}
export function View_HeaderComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import5.LongMessagePipe,([] as any[])),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'a',[
      [
        'class',
        'logo'
      ]
      ,
      [
        'href',
        'https://dataspace.pl'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'alt',
        'Data Space'
      ]
      ,
      [
        'src',
        'assets/images/logo.png'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'breadcrumb',([] as any[]),(null as any),(null as any),(null as any),import6.View_BreadcrumbComponent_0,import6.RenderType_BreadcrumbComponent)),
    import0.ɵdid(770048,(null as any),0,import7.BreadcrumbComponent,[
      import1.Router,
      import8.BreadcrumbService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'cart'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_1)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_2)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_3)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_HeaderComponent_8)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    \n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import9.HeaderComponent = v.component;
    ck(v,10,0);
    const currVal_0:any = co.cartOrCheckout;
    ck(v,18,0,currVal_0);
    const currVal_1:any = co.cart;
    ck(v,21,0,currVal_1);
    const currVal_2:any = co.authenticated;
    ck(v,26,0,currVal_2);
    const currVal_3:boolean = !co.authenticated;
    ck(v,30,0,currVal_3);
  },(null as any));
}
function View_HeaderComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-header',([] as any[]),(null as any),(null as any),(null as any),View_HeaderComponent_0,RenderType_HeaderComponent)),
    import0.ɵdid(245760,(null as any),0,import9.HeaderComponent,[
      import10.ApiService,
      import11.ResponseService,
      import4.TranslateService,
      import12.LanguageService,
      import13.AuthService,
      import14.UserService,
      import15.CompanyService,
      import16.LocalStorageService,
      import17.CartService,
      import1.Router
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const HeaderComponentNgFactory:import0.ComponentFactory<import9.HeaderComponent> = import0.ɵccf('app-header',import9.HeaderComponent,View_HeaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layout/header.component.ngfactory.ts